import * as d3 from 'd3';

const closure = mainApp => {
    mainApp.addButtons = function(container, slideParams) {
        if (slideParams.buttonText.length === 1) {
            var nextButton = container
                .append('g')
                .attr('class', 'slide-button-container')
                .attr(
                    'transform',
                    'translate(' +
                        (mainApp.params.width - 50) / 2 +
                        ',' +
                        (mainApp.params.height - 190) +
                        ')'
                )
                .attr('width', 150)
                .attr('height', 60);

            nextButton
                .append('rect')
                .attr('class', 'slide-button')
                .attr('width', 150)
                .attr('height', 60);

            nextButton
                .append('text')
                .attr('class', 'slide-button-text text-header')
                .attr('transform', 'translate(' + 75 + ',' + 38 + ')')
                .attr('text-anchor', 'middle')
                .style('font-size', '24px')
                .text(slideParams.buttonText);

            nextButton
                .append('rect')
                .attr('class', 'slide-button-mask')
                .attr('width', 150)
                .attr('height', 60)
                .style('opacity', '0')
                .on('click', function() {
                    if (slideParams.type === 'animation') {
                        mainApp.showSlide(mainApp.curSlide + 1);
                        nextButton.remove();
                    } else {
                        mainApp.clearSlide(function() {
                            mainApp.showSlide(mainApp.curSlide + 1);
                        });
                    }
                });
        } else {
            var buttons = [];

            for (var i = 0; i < slideParams.buttonText.length; i++) {
                buttons[i] = container
                    .append('g')
                    .attr('class', 'slide-button-container')
                    .attr(
                        'transform',
                        'translate(' +
                            (mainApp.params.width - 160 + 160 * 2 * i) / 2 +
                            ',' +
                            (mainApp.params.height - 80) +
                            ')'
                    )
                    .attr('width', 100)
                    .attr('height', 40);

                buttons[i]
                    .append('rect')
                    .attr('class', 'slide-button')
                    .attr('width', 100)
                    .attr('height', 40);

                buttons[i]
                    .append('text')
                    .attr('class', 'slide-button-text text-header')
                    .attr('transform', function() {
                        if (i == 0) {
                            return 'translate(' + 58 + ',' + 27 + ')';
                        } else {
                            return 'translate(' + 42 + ',' + 27 + ')';
                        }
                    })
                    .attr('text-anchor', 'middle')
                    .style('font-size', '20px')
                    .text(slideParams.buttonText[i]);

                buttons[i]
                    .append('path')
                    .attr('class', 'button-arrow')
                    .attr('d', function() {
                        if (i == 0) {
                            return 'M 18 12 10 20 18 28';
                        } else {
                            return 'M 82 12 90 20 82 28';
                        }
                    });

                buttons[i]
                    .append('rect')
                    .attr('class', 'slide-button-mask')
                    .attr('width', 100)
                    .attr('height', 40)
                    .style('opacity', '0');
            }
            var replayButton;
            if (slideParams.type === 'animation') {
                replayButton = container
                    .append('g')
                    .attr('class', 'slide-button-container')
                    .attr(
                        'transform',
                        'translate(' +
                            (mainApp.params.width + 60) / 2 +
                            ',' +
                            (mainApp.params.height - 80) +
                            ')'
                    )
                    .attr('width', 40)
                    .attr('height', 40);

                replayButton
                    .append('rect')
                    .attr('class', 'slide-button')
                    .attr('width', 40)
                    .attr('height', 40);

                var replayGroup = replayButton
                    .append('g')
                    .attr('class', 'slide-button-text')
                    .attr('transform', 'translate(' + 4 + ',' + 4 + ')');
                replayGroup
                    .append('path')
                    .attr(
                        'd',
                        'M27.877,19.662c0.385-1.23,0.607-2.531,0.607-3.884c0-7.222-5.83-13.101-13.029-13.194v4.238    c4.863,0.093,8.793,4.071,8.793,8.956c0,0.678-0.088,1.332-0.232,1.966l-3.963-1.966l2.76,8.199l8.197-2.762L27.877,19.662z'
                    );
                replayGroup
                    .append('path')
                    .attr(
                        'd',
                        'M7.752,16.222c0-0.678,0.088-1.332,0.232-1.967l3.963,1.967l-2.76-8.199L0.99,10.785l3.133,1.553    c-0.384,1.23-0.607,2.531-0.607,3.885c0,7.223,5.83,13.1,13.03,13.194v-4.238C11.682,25.086,7.752,21.107,7.752,16.222z'
                    );

                replayButton
                    .append('rect')
                    .attr('class', 'slide-button-mask')
                    .attr('width', 40)
                    .attr('height', 40)
                    .style('opacity', '0');

                replayButton.on('click', function() {
                    mainApp.showSlide(mainApp.curSlide);
                    buttons[0].remove();
                    buttons[1].remove();
                    replayButton.remove();
                });
            }

            buttons[0].on('click', function() {
                if (slideParams.type === 'animation') {
                    mainApp.showSlide(mainApp.curSlide - 1);
                    buttons[0].remove();
                    buttons[1].remove();
                    if (slideParams.type === 'animation') {
                        replayButton.remove();
                    }
                } else {
                    mainApp.clearSlide(function() {
                        mainApp.showSlide(mainApp.curSlide - 1);
                    });
                }
            });

            buttons[1].on('click', function() {
                if (slideParams.type === 'animation') {
                    mainApp.showSlide(mainApp.curSlide + 1);
                    buttons[0].remove();
                    buttons[1].remove();
                    if (slideParams.type === 'animation') {
                        replayButton.remove();
                    }
                } else {
                    mainApp.clearSlide(function() {
                        mainApp.showSlide(mainApp.curSlide + 1);
                    });
                }
            });
        }
    };

    mainApp.showSlide = function(slideNum) {
        if (mainApp.slides[slideNum] === undefined) {
            slideNum = 0;
        }

        if (mainApp.slides[slideNum].type == 'animation') {
            mainApp.year(mainApp.slides[slideNum].startYear);
        }

        mainApp.zoom.scaleTo(mainApp.mapContainer.transition().duration(500), 1);

        mainApp.curSlide = slideNum;
        var slide = mainApp.slides[slideNum];
        var slideType = slide.type;

        switch (slideType) {
            case 'text':
                mainApp.textSlide(slide);
                break;

            case 'graph':
                mainApp.graphSlide(slide);
                break;

            case 'animation':
                mainApp.zoom.transform(
                    mainApp.mapContainer.transition().duration(500),
                    d3.zoomIdentity
                        .translate(slide.transform.x, slide.transform.y)
                        .scale(slide.transform.k)
                );
                mainApp.animateYears(slide);
                break;
        }
    };

    mainApp.animateYears = function(slideParams) {
        var clickBlock = mainApp.svg
            .append('g')
            .attr('class', 'click-block')
            .style('opacity', '0');

        clickBlock
            .append('rect')
            .attr('class', 'slide-background')
            .attr('width', +mainApp.svg.attr('width'))
            .attr('height', +mainApp.svg.attr('height'));

        mainApp.slider
            .transition()
            .duration(slideParams.duration)
            .delay(slideParams.delay)
            .ease(d3.easeLinear)
            .tween('year', function() {
                var i = d3.interpolate(slideParams.startYear, slideParams.endYear);
                return function(t) {
                    mainApp.year(i(t));
                };
            })
            .on('end', function() {
                clickBlock.remove();
                mainApp.addButtons(mainApp.svg, slideParams);
            });
    };

    mainApp.graphSlide = function(slideParams) {
        var svg = d3.select('#map-svg');

        var slide = mainApp.svg.append('g').attr('class', 'slide');

        slide
            .style('opacity', 0)
            .transition()
            .duration(500)
            .style('opacity', 0.95);

        slide
            .append('rect')
            .attr('class', 'slide-background')
            .attr('width', +svg.attr('width'))
            .attr('height', +svg.attr('height'));

        var textArea = slide
            .append('g')
            .attr('class', 'slide-text-area')
            .attr('transform', 'translate(' + 50 + ',' + 0 + ')')
            .attr('width', +svg.attr('width') - 100);

        textArea
            .append('text')
            .attr('class', 'title text-header')
            .attr('x', 50)
            .attr('y', 100)
            .attr('dx', (+svg.attr('width') - 100) / 2)
            .attr('dy', 0)
            .attr('text-anchor', 'middle')
            .text(slideParams.title)
            .call(mainApp.textWrap, +svg.attr('width') - 100);

        slideParams.graph(slide);

        mainApp.addButtons(slide, slideParams);
    };

    mainApp.textSlide = function(slideParams) {
        var svg = d3.select('#map-svg');

        var slide = mainApp.svg.append('g').attr('class', 'slide');

        slide
            .style('opacity', 0)
            .transition()
            .duration(500)
            .style('opacity', 0.95);

        slide
            .append('rect')
            .attr('class', 'slide-background')
            .attr('width', +svg.attr('width'))
            .attr('height', +svg.attr('height'));

        var textArea = slide
            .append('g')
            .attr('class', 'slide-text-area')
            .attr('transform', 'translate(' + 50 + ',' + 50 + ')')
            .attr('width', +svg.attr('width') - 100);

        textArea
            .append('text')
            .attr('class', 'title text-header')
            .attr('x', 50)
            .attr('y', 100)
            .attr('dx', (+svg.attr('width') - 100) / 2)
            .attr('dy', 0)
            .attr('text-anchor', 'middle')
            .text(slideParams.title)
            .call(mainApp.textWrap, +svg.attr('width') - 100);

        textArea
            .append('text')
            .attr('class', 'slide-text text-body')
            .attr('x', 50)
            .attr('y', 200)
            .attr('dx', 0)
            .attr('dy', 0)
            .text(slideParams.text)
            .call(mainApp.textWrap, +svg.attr('width') - 100);

        mainApp.addButtons(slide, slideParams);
    };

    mainApp.clearSlide = function(callback) {
        var slide = d3.select('.slide');

        slide
            .transition()
            .duration(500)
            .style('opacity', 0)
            .on('end', function() {
                callback();
            })
            .remove();
    };
};

export default closure;
